const UNAVAILABLE = 'Unavailable';
const SEMVER_PATTERN = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-([0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*))?(?:\+[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?$/;
const REVISION_PATTERN = /^[0-9a-fA-F]{7,40}$/;

const CONTEXT_LABELS = {
  production: 'Alpha',
  'deploy-preview': 'Alpha Preview',
  'branch-deploy': 'Alpha Branch'
};

function getContextLabel(context) {
  return Object.prototype.hasOwnProperty.call(CONTEXT_LABELS, context)
    ? CONTEXT_LABELS[context]
    : 'Local';
}

function isValidSemanticVersion(version) {
  if (typeof version !== 'string') return false;

  const match = version.match(SEMVER_PATTERN);
  if (!match) return false;

  const prerelease = match[4];
  return !prerelease || !prerelease.split('.').some(identifier => (
    /^\d+$/.test(identifier) && identifier.length > 1 && identifier.startsWith('0')
  ));
}

function formatBuildTimestamp(timestamp) {
  if (typeof timestamp !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(timestamp)) {
    return UNAVAILABLE;
  }

  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime()) || date.toISOString() !== timestamp) return UNAVAILABLE;

  const month = new Intl.DateTimeFormat('en-GB', { month: 'short', timeZone: 'UTC' }).format(date);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  return `${day} ${month} ${date.getUTCFullYear()} ${hours}:${minutes} UTC`;
}

function getReleaseIdentity(metadata = {}) {
  const {
    version = process.env.REACT_APP_BUILD_VERSION,
    context = process.env.REACT_APP_BUILD_CONTEXT,
    revision = process.env.REACT_APP_BUILD_REVISION,
    timestamp = process.env.REACT_APP_BUILD_TIMESTAMP
  } = metadata;

  return {
    version: isValidSemanticVersion(version) ? version : UNAVAILABLE,
    contextLabel: getContextLabel(context),
    revision: typeof revision === 'string' && REVISION_PATTERN.test(revision)
      ? revision.slice(0, 7).toLowerCase()
      : UNAVAILABLE,
    builtAt: formatBuildTimestamp(timestamp)
  };
}

export { formatBuildTimestamp, getContextLabel, getReleaseIdentity, UNAVAILABLE };
